export default __webpack_public_path__ + "static/media/desicon.f8793648.png";